"use client";

import { VehicleGetDTO } from "@alba-cars/common-modules";
import { useQuery } from "@tanstack/react-query";

import SuggestedLoader from "./SuggestedLoader";

import CarsCard from "@/components/ui/CarsCard";
import { fetchCarSuggestions } from "@/lib/api/client/fetchCarSuggestions";

interface SuggestionsGridProps {
  queryOptions: Omit<VehicleGetDTO, "toPlain" | "validate">;
}

const SuggestionsGrid: React.FC<SuggestionsGridProps> = ({ queryOptions }) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["suggested-cars", queryOptions],
    queryFn: () => fetchCarSuggestions(queryOptions),
    refetchOnWindowFocus: false,
  });

  if (isError)
    return (
      <div className="inter text-sm text-primary">
        <p>We apologize for the inconvenience. There was a problem loading the suggested cars.</p>
        <button className="text-primary-foreground underline" onClick={() => refetch()}>
          Try Again
        </button>
      </div>
    );

  if (isLoading) return <SuggestedLoader />;

  const cars = data?.data?.result ?? [];

  return (
    <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {cars.map((car) => (
        <CarsCard key={car.id} car={car} />
      ))}
    </div>
  );
};

export default SuggestionsGrid;
